import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

import { Textfit } from "react-textfitfix"

import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat'
import DirectionsRailwayIcon from '@mui/icons-material/DirectionsRailway'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'

const BoardPassPrimary = () => {
  const { template, instanceData, scannerInstanceData, model, subType } = useContext(PassContext)

  const transitType = subType
  const fields = template.primaryFields

  if (fields?.length) {
    const originLabel = dataSelector({ template: fields[0], instanceData, scannerInstanceData, path: "label" })
    const originValue = dataSelector({ template: fields[0], instanceData, scannerInstanceData, path: "value" })

    const destinationLabel = dataSelector({ template: fields[1], instanceData, scannerInstanceData, path: "label" })
    const destinationValue = dataSelector({ template: fields[1], instanceData, scannerInstanceData, path: "value" })

    return (
      <PopupEditor title="Primary Fields" path="primaryFields">
      <table className="primary editable">
        <tbody>
          <tr style={{ color: model.labelColor }}>
            <td colSpan={2} className="label uppercase truncate w-full"><Textfit mode="single" min={8} max={12}>{originLabel}</Textfit></td>
            <td colSpan={2} className="label uppercase truncate w-full" align="right"><Textfit mode="single" min={8} max={12}>{destinationLabel}</Textfit></td>
          </tr>
          <tr style={{ color: model.foregroundColor }}>
            <td className="value" valign="top" ><Textfit mode="single" min={8} max={36}>{originValue}</Textfit></td>
            <td className="icon" valign="top" colSpan={2} width={40}><TransitIcon transitType={transitType}/></td>
            <td className="value" valign="top" align="right"><Textfit mode="single" min={8} max={36}>{destinationValue}</Textfit></td>
          </tr>
        </tbody>
      </table>
      </PopupEditor>
    )
  }
}

export default BoardPassPrimary

const TransitIcon = ({ transitType }) => {
  switch (transitType) {
    case "PKTransitTypeAir": return <AirplanemodeActiveIcon className="rotate-90 icon" />
    case "PKTransitTypeGeneric": return <ArrowForwardIcon className="icon" />
    case "PKTransitTypeBoat": return <DirectionsBoatIcon className="icon" />
    case "PKTransitTypeTrain": return <DirectionsRailwayIcon className="icon" />
    case "PKTransitTypeBus": return <DirectionsBusIcon className="icon" />
  }
}
